/**
 * Functions related to the site's header.
 */
import divi from '../../helpers/divi';
import headerElements from './parts/headerElements';
import menuMobileToggle from './parts/menuMobileToggle';
import menuDesktopDropdown from './parts/menuDesktopDropdown';

const header = () => {
  const init = () => {
    headerElements.init();

    if (headerElements.hasHeader() && !divi.inVisualBuilder()) {
      menuMobileToggle.init();
      menuDesktopDropdown.init();
    }
  };

  return {
    ...headerElements,
    init,
  };
};

export default header();
